import mixpanel from 'mixpanel-browser'

if (process.env.REACT_APP_MIXPANEL_KEY) {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_KEY)
}
export default mixpanel
